"use client";

import { Button } from "@scott/ui-d2c";
import { useParams, useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import { logoutAction } from "@/actions/logout-action";
import { useInfoMessage } from "@/providers/info-message-provider";

const REDIRECT_DELAY_MS = 2000;

export function LogoutButton() {
  const t = useTranslations("header");
  const { handleSetMessage } = useInfoMessage();
  const navParams = useParams();
  const router = useRouter();

  const handleLogoutClick = async () => {
    try {
      const result = await logoutAction();
      if (result?.success) {
        // Dispatch custom event to notify components about logout
        document.dispatchEvent(new CustomEvent("user-logout"));

        handleSetMessage({
          translationChunkName: "header",
          translationFieldName: "userSession.logoutSuccess",
          type: "success",
        });
        setTimeout(() => {
          router.replace(`/${navParams.country}/${navParams.lang}/logout`);
        }, REDIRECT_DELAY_MS);
      } else {
        handleSetMessage({
          translationChunkName: "header",
          translationFieldName: "userSession.errorMessages.genericError",
          type: "error",
        });
      }
      // biome-ignore lint/correctness/noUnusedVariables: -
    } catch (err) {
      handleSetMessage({
        translationChunkName: "header",
        translationFieldName: "userSession.errorMessages.genericError",
        type: "error",
      });
    }
  };

  return (
    <Button
      className="w-full font-bold"
      onClick={handleLogoutClick}
      size={"sm"}
      variant="outline"
    >
      {t("userSession.logoutLabel").toUpperCase()}
    </Button>
  );
}
